// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"58":"1ff75f2d","214":"b39a97d6","324":"3eee2cdd","458":"56c1f1f4","577":"66801e42","652":"256a6b6e","682":"d5252985","783":"c66ca607","812":"a8661619","847":"cd17b0ce","867":"1897a02c","887":"23b7f8a1","904":"538f6d3c","985":"de897744","997":"f487d4a9"}[chunkId] + ".js";
};